import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-trial-balance',
  templateUrl: './trial-balance.component.html',
  styleUrls: ['./trial-balance.component.css']
})
export class TrialBalanceComponent implements OnInit {

  years: any;
  year_add: any = '';
  admin_data: any;
  enableAdd: boolean = false;
  enableEdit: boolean = false;
  enableEditIndex: any = null;
  year_select = parseInt(new DatePipe('en-US').transform(new Date(), 'yyyy')!) + 543;
  gf_list: any
  data_years = [] as any;
  all_data = [] as any;
  select_data = {
    asset: [] as any,
    creditor: [] as any,
    fund: [] as any,
    income: [] as any,
    cost: [] as any,
    gf: [] as any,
    nb: [] as any
  }
  edit_data = {
    fiscal_year: 0,
    type: '',
    code: '',
    list: '',
    ori_balance: 0,
    oct: {
      value: 0,
      comment: ''
    },
    nov: {
      value: 0,
      comment: ''
    },
    dec: {
      value: 0,
      comment: ''
    },
    jan: {
      value: 0,
      comment: ''
    },
    feb: {
      value: 0,
      comment: ''
    },
    mar: {
      value: 0,
      comment: ''
    },
    apr: {
      value: 0,
      comment: ''
    },
    may: {
      value: 0,
      comment: ''
    },
    jun: {
      value: 0,
      comment: ''
    },
    jul: {
      value: 0,
      comment: ''
    },
    aug: {
      value: 0,
      comment: ''
    },
    sep: {
      value: 0,
      comment: ''
    },
    adjust: '',
    user_id: 0,
    status: ''
  }
  diff = {
    list: 'Diff. (งบทดลอง)',
    ori_balance: 0,
    oct: {
      value: 0,
      comment: ''
    },
    nov: {
      value: 0,
      comment: ''
    },
    dec: {
      value: 0,
      comment: ''
    },
    jan: {
      value: 0,
      comment: ''
    },
    feb: {
      value: 0,
      comment: ''
    },
    mar: {
      value: 0,
      comment: ''
    },
    apr: {
      value: 0,
      comment: ''
    },
    may: {
      value: 0,
      comment: ''
    },
    jun: {
      value: 0,
      comment: ''
    },
    jul: {
      value: 0,
      comment: ''
    },
    aug: {
      value: 0,
      comment: ''
    },
    sep: {
      value: 0,
      comment: ''
    },
    sumRow: 0
  }
  diff_gn = {
    list: 'Diff. (GF & NBMS)',
    ori_balance: 0,
    oct: {
      value: 0,
      comment: ''
    },
    nov: {
      value: 0,
      comment: ''
    },
    dec: {
      value: 0,
      comment: ''
    },
    jan: {
      value: 0,
      comment: ''
    },
    feb: {
      value: 0,
      comment: ''
    },
    mar: {
      value: 0,
      comment: ''
    },
    apr: {
      value: 0,
      comment: ''
    },
    may: {
      value: 0,
      comment: ''
    },
    jun: {
      value: 0,
      comment: ''
    },
    jul: {
      value: 0,
      comment: ''
    },
    aug: {
      value: 0,
      comment: ''
    },
    sep: {
      value: 0,
      comment: ''
    },
    sumRow: 0
  }
  sumCol: any;

  //iframe version
  maximized = false
  iframe_url: any;
  urlSafe!: SafeResourceUrl;

  iframe_type = 'trialbalance'
  iframe_data: any;
  iframe_form = new FormGroup({
    year: new FormControl(''),
    iframe: new FormControl('', [Validators.required]),
    edit: new FormControl('', [Validators.required]),
    type: new FormControl('')
  });

  constructor(
    public services: ApiService,
    public sanitizer: DomSanitizer,
  ) { }

  async ngOnInit(): Promise<void> {

    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    document.getElementById('finances')!.classList.toggle("active");
    document.getElementById('finance')!.classList.toggle("show");
    document.getElementById('trialbalance')!.classList.toggle("active");
    // this.years = this.services.fiscal_year;
    // this.getDataAlll();
    // this.createSumCol();

    await this.setIframe()
  }

  ngOnDestroy() {
    document.getElementById('finances')!.classList.remove("active");
    document.getElementById('finance')!.classList.remove("show");
    document.getElementById('trialbalance')!.classList.remove("active");
  }

  async setIframe() {
    let arr_iframe = [] as any
    await this.services.get('m_iframe_url').then((res: any) => {
      arr_iframe = res.filter((f: any) => {
        f.id = Number(f.id)
        if (f.type == this.iframe_type) {
          if (f.iframe) {
            f.iframe = JSON.parse(f.iframe)
            f.iframe_url = f.iframe.join("'");
          }
          if (f.edit) {
            f.edit = JSON.parse(f.edit)
            f.edit_url = f.edit.join("'");
          }
        }
        return f.type == this.iframe_type
      })
    })
    if (arr_iframe.length > 0) {
      arr_iframe = arr_iframe.sort((a: any, b: any) => (a.id > b.id) ? -1 : ((b.id > a.id) ? 1 : 0))
      this.iframe_data = arr_iframe[0]
      this.iframe_url = this.iframe_data.iframe_url;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    }
  }
  goToEdit(): void {
    if (this.iframe_data) {
      window.open(this.iframe_data.edit_url, "_blank");
    }
  }
  addIframe() {
    this.iframe_form.patchValue({
      type: this.iframe_type,
      iframe: JSON.stringify(this.iframe_form.value.iframe.split("'")),
      edit: JSON.stringify(this.iframe_form.value.edit.split("'")),
      year: ''
    })

    this.services.create('m_iframe_url', this.iframe_form.value).then((res: any) => {
      if (res) {
        this.setIframe()
        this.iframe_form.reset()
        $('#updateURL_ht').modal('hide');
        Swal.fire({
          title: 'อัพเดต URL สำเร็จ',
          icon: 'success',
          confirmButtonText: `ตกลง`,
          showConfirmButton: false,
          timer: 1500
        })

      }
    })
  }

  async getDataAlll() {
    this.all_data = [] as any;
    await this.services.get('m_trialbalance').then((res: any) => {
      res.reverse().forEach((data: any) => {
        if (data.status == 'Enable') {
          this.data_years.push(parseInt(data.fiscal_year))
          data.oct = JSON.parse(data.oct);
          data.nov = JSON.parse(data.nov);
          data.dec = JSON.parse(data.dec);
          data.jan = JSON.parse(data.jan);
          data.feb = JSON.parse(data.feb);
          data.mar = JSON.parse(data.mar);
          data.apr = JSON.parse(data.apr);
          data.may = JSON.parse(data.may);
          data.jun = JSON.parse(data.jun);
          data.jul = JSON.parse(data.jul);
          data.aug = JSON.parse(data.aug);
          data.sep = JSON.parse(data.sep);
          this.all_data.push(data);
        }
      });
    })
    this.data_years = [...new Set(this.data_years)].sort();
    this.select_year(this.year_select)
  }
  async select_year(year: any) {
    this.gf_list = ['รายการปรับปรุงมีผลกระทบปี งปม.' + (year - 1), 'P/L MONTH', 'P/L ปี งปม.' + year, 'ทุน', 'กำไร/ขาดทุนสะสม']
    var sumRow = 0
    let sumGf: any;
    let sumNb: any;
    this.all_data = [] as any;
    this.select_data = {
      asset: [] as any,
      creditor: [] as any,
      fund: [] as any,
      income: [] as any,
      cost: [] as any,
      gf: [] as any,
      nb: [] as any
    }
    this.diff = {
      list: 'Diff. (งบทดลอง)',
      ori_balance: 0,
      oct: {
        value: 0,
        comment: ''
      },
      nov: {
        value: 0,
        comment: ''
      },
      dec: {
        value: 0,
        comment: ''
      },
      jan: {
        value: 0,
        comment: ''
      },
      feb: {
        value: 0,
        comment: ''
      },
      mar: {
        value: 0,
        comment: ''
      },
      apr: {
        value: 0,
        comment: ''
      },
      may: {
        value: 0,
        comment: ''
      },
      jun: {
        value: 0,
        comment: ''
      },
      jul: {
        value: 0,
        comment: ''
      },
      aug: {
        value: 0,
        comment: ''
      },
      sep: {
        value: 0,
        comment: ''
      },
      sumRow: 0
    }
    this.diff_gn = {
      list: 'Diff. (GF & NBMS)',
      ori_balance: 0,
      oct: {
        value: 0,
        comment: ''
      },
      nov: {
        value: 0,
        comment: ''
      },
      dec: {
        value: 0,
        comment: ''
      },
      jan: {
        value: 0,
        comment: ''
      },
      feb: {
        value: 0,
        comment: ''
      },
      mar: {
        value: 0,
        comment: ''
      },
      apr: {
        value: 0,
        comment: ''
      },
      may: {
        value: 0,
        comment: ''
      },
      jun: {
        value: 0,
        comment: ''
      },
      jul: {
        value: 0,
        comment: ''
      },
      aug: {
        value: 0,
        comment: ''
      },
      sep: {
        value: 0,
        comment: ''
      },
      sumRow: 0
    }
    await this.services.get('m_trialbalance').then((res: any) => {
      res.reverse().forEach((data: any) => {
        if (data.status == 'Enable') {
          data.oct = JSON.parse(data.oct);
          data.nov = JSON.parse(data.nov);
          data.dec = JSON.parse(data.dec);
          data.jan = JSON.parse(data.jan);
          data.feb = JSON.parse(data.feb);
          data.mar = JSON.parse(data.mar);
          data.apr = JSON.parse(data.apr);
          data.may = JSON.parse(data.may);
          data.jun = JSON.parse(data.jun);
          data.jul = JSON.parse(data.jul);
          data.aug = JSON.parse(data.aug);
          data.sep = JSON.parse(data.sep);
          this.all_data.push(data);
        }
      });
    })
    await this.all_data.forEach(async (data: any) => {
      if (parseInt(data.fiscal_year) == parseInt(year)) {
        sumRow = [parseFloat(data.ori_balance), parseFloat(data.oct.value), parseFloat(data.nov.value), parseFloat(data.dec.value), parseFloat(data.jan.value), parseFloat(data.feb.value), parseFloat(data.mar.value),
        parseFloat(data.apr.value), parseFloat(data.may.value), parseFloat(data.jun.value), parseFloat(data.jul.value), parseFloat(data.aug.value), parseFloat(data.sep.value)].reduce((a, b) => a + b, 0);
        data.sumRow = this.fixDecimal(sumRow);
        switch (data.type) {
          case 'สินทรัพย์':
            this.select_data.asset.push(data);
            await this.sumDiff(data);
            break;
          case 'เจ้าหนี้':
            this.select_data.creditor.push(data);
            await this.sumDiff(data);
            break;
          case 'ทุน':
            this.select_data.fund.push(data);
            await this.sumDiff(data);
            break;
          case 'รายได้':
            this.select_data.income.push(data);
            await this.sumDiff(data);
            break;
          case 'ค่าใช้จ่าย':
            this.select_data.cost.push(data);
            await this.sumDiff(data);
            break;
          case 'GFMIF':
            this.select_data.gf.push(data);
            break;
          case 'NBMS':
            this.select_data.nb.push(data);
            break;
          default:
            // console.log("No such day exists!");
            break;
        }
      }
    });

    this.select_data.asset = this.select_data.asset.sort((a: any, b: any) => (a.code < b.code) ? -1 : ((b.code < a.code) ? 1 : 0))
    this.select_data.creditor = this.select_data.creditor.sort((a: any, b: any) => (a.code < b.code) ? -1 : ((b.code < a.code) ? 1 : 0))
    this.select_data.fund = this.select_data.fund.sort((a: any, b: any) => (a.code < b.code) ? -1 : ((b.code < a.code) ? 1 : 0))
    this.select_data.income = this.select_data.income.sort((a: any, b: any) => (a.code < b.code) ? -1 : ((b.code < a.code) ? 1 : 0))
    this.select_data.cost = this.select_data.cost.sort((a: any, b: any) => (a.code < b.code) ? -1 : ((b.code < a.code) ? 1 : 0))

    if (this.select_data.asset.length != 0) {
      this.select_data.asset.forEach((data: any) => {
        this.sumColumn(data);
      });
      this.select_data.asset.push(this.sumCol)
    }
    this.createSumCol();
    if (this.select_data.creditor.length != 0) {
      this.select_data.creditor.forEach((data: any) => {
        this.sumColumn(data);
      });
      this.select_data.creditor.push(this.sumCol)
    }
    this.createSumCol();
    if (this.select_data.fund.length != 0) {
      this.select_data.fund.forEach((data: any) => {
        this.sumColumn(data);
      });
      this.select_data.fund.push(this.sumCol)
    }
    this.createSumCol();
    if (this.select_data.income.length != 0) {
      this.select_data.income.forEach((data: any) => {
        this.sumColumn(data);
      });
      this.select_data.income.push(this.sumCol)
    }
    this.createSumCol();
    if (this.select_data.cost.length != 0) {
      this.select_data.cost.forEach((data: any) => {
        this.sumColumn(data);
      });
      this.select_data.cost.push(this.sumCol)
    }
    this.createSumCol();
    if (this.select_data.gf.length != 0) {
      let fund = await this.select_data.gf.filter((res: any) => {
        return res.list.match('ทุน')
      })

      if (fund.length != 0) {
        fund = fund[0]
        this.sumColumn(fund);
      }

      let stash = await this.select_data.gf.filter((res: any) => {
        return res.list.match('กำไร/ขาดทุนสะสม')
      })

      if (stash.length != 0) {
        stash = stash[0]
        this.sumColumn(stash);
      }
      sumGf = this.sumCol
      this.select_data.gf.push(this.sumCol)
    }
    this.createSumCol();
    if (this.select_data.nb.length != 0) {
      let fund = await this.select_data.nb.filter((res: any) => {
        return res.list.match('ทุน')
      })

      if (fund.length != 0) {
        fund = fund[0]
        this.sumColumn(fund);
      }

      let stash = await this.select_data.nb.filter((res: any) => {
        return res.list.match('กำไร/ขาดทุนสะสม')
      })

      if (stash.length != 0) {
        stash = stash[0]
        this.sumColumn(stash);
      }
      sumNb = this.sumCol
      this.select_data.nb.push(this.sumCol)
    }
    this.createSumCol();

    this.sumDiffGN(sumGf, sumNb);

    //fix 0 to null
    this.select_data.asset.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.select_data.creditor.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.select_data.fund.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.select_data.income.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.select_data.cost.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.select_data.gf.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.select_data.nb.forEach((data: any) => {
      this.fixNumber(data);
    });
    this.diff = this.fixNumber(this.diff);
    this.diff_gn = this.fixNumber(this.diff_gn);
  }
  async addYear() {
    await this.data_years.push(this.year_add)
  }

  async onClickAdd(type: any) {
    this.edit_data = this.fixData(this.edit_data);
    let new_data = {
      fiscal_year: this.year_select,
      type: type,
      code: this.edit_data.code,
      list: this.edit_data.list,
      ori_balance: this.edit_data.ori_balance,
      oct: JSON.stringify(this.edit_data.oct),
      nov: JSON.stringify(this.edit_data.nov),
      dec: JSON.stringify(this.edit_data.dec),
      jan: JSON.stringify(this.edit_data.jan),
      feb: JSON.stringify(this.edit_data.feb),
      mar: JSON.stringify(this.edit_data.mar),
      apr: JSON.stringify(this.edit_data.apr),
      may: JSON.stringify(this.edit_data.may),
      jun: JSON.stringify(this.edit_data.jun),
      jul: JSON.stringify(this.edit_data.jul),
      aug: JSON.stringify(this.edit_data.aug),
      sep: JSON.stringify(this.edit_data.sep),
      user_id: parseInt(this.admin_data.id),
      adjust: this.edit_data.adjust,
      status: 'Enable'
    }
    Swal.fire({
      title: 'ยืนยันการบันทึกรายการใหม่',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true
    }).then((res: any) => {
      if (res.isConfirmed == true) {
        this.services.create('m_trialbalance', new_data).then((res: any) => {
          this.getDataAlll();
          Swal.fire({
            title: 'บันทึกรายการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
          this.closeAdd();
        })
      }
    })

  }
  async closeAdd() {
    this.enableAdd = false;
    this.edit_data = {
      fiscal_year: 0,
      type: '',
      code: '',
      list: '',
      ori_balance: 0,
      oct: {
        value: 0,
        comment: ''
      },
      nov: {
        value: 0,
        comment: ''
      },
      dec: {
        value: 0,
        comment: ''
      },
      jan: {
        value: 0,
        comment: ''
      },
      feb: {
        value: 0,
        comment: ''
      },
      mar: {
        value: 0,
        comment: ''
      },
      apr: {
        value: 0,
        comment: ''
      },
      may: {
        value: 0,
        comment: ''
      },
      jun: {
        value: 0,
        comment: ''
      },
      jul: {
        value: 0,
        comment: ''
      },
      aug: {
        value: 0,
        comment: ''
      },
      sep: {
        value: 0,
        comment: ''
      },
      adjust: '',
      user_id: 0,
      status: ''
    }
  }
  async onClickEdit(data: any, i: any) {
    this.enableEdit = true;
    this.enableEditIndex = i;
    this.edit_data = {
      fiscal_year: parseInt(data.fiscal_year),
      type: data.type,
      code: data.code,
      list: data.list,
      ori_balance: data.ori_balance,
      oct: data.oct,
      nov: data.nov,
      dec: data.dec,
      jan: data.jan,
      feb: data.feb,
      mar: data.mar,
      apr: data.apr,
      may: data.may,
      jun: data.jun,
      jul: data.jul,
      aug: data.aug,
      sep: data.sep,
      adjust: data.adjust,
      user_id: this.admin_data.id,
      status: data.status
    }
  }
  async onClickDel(data: any) {
    let del_data = {
      fiscal_year: parseInt(data.fiscal_year),
      type: data.type,
      code: data.code,
      list: data.list,
      ori_balance: parseFloat(data.ori_balance),
      oct: JSON.stringify(data.oct),
      nov: JSON.stringify(data.nov),
      dec: JSON.stringify(data.dec),
      jan: JSON.stringify(data.jan),
      feb: JSON.stringify(data.feb),
      mar: JSON.stringify(data.mar),
      apr: JSON.stringify(data.apr),
      may: JSON.stringify(data.may),
      jun: JSON.stringify(data.jun),
      jul: JSON.stringify(data.jul),
      aug: JSON.stringify(data.aug),
      sep: JSON.stringify(data.sep),
      user_id: parseInt(this.admin_data.id),
      adjust: data.adjust,
      status: "Disable"
    }
    Swal.fire({
      title: 'ยืนยันการลบรายการ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true
    }).then((res: any) => {
      if (res.isConfirmed == true) {
        this.services.update('m_trialbalance', parseInt(data.id), del_data).then((res: any) => {
          this.getDataAlll();
          Swal.fire({
            title: 'ลบรายการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
        })
      }
    })

  }
  async onClickChange(data: any) {
    let pl: any
    let pl_year: any
    let stash: any
    this.edit_data = this.fixData(this.edit_data)
    if (this.edit_data.type == "GFMIF") {
      if (data.list === "P/L MONTH") {
        pl_year = this.select_data.gf.filter((res: any) => {
          return res.list.match("P/L ปี งปม." + this.year_select)
        })
        stash = this.select_data.gf.filter((res: any) => {
          return res.list.match("กำไร/ขาดทุนสะสม")
        })
        if (pl_year.length > 0) {
          pl_year = pl_year[0];

          //P/L ปี งปม.
          pl_year.oct.value = this.edit_data.oct.value
          pl_year.nov.value = pl_year.oct.value + this.edit_data.nov.value
          pl_year.dec.value = pl_year.nov.value + this.edit_data.dec.value
          pl_year.jan.value = pl_year.dec.value + this.edit_data.jan.value
          pl_year.feb.value = pl_year.jan.value + this.edit_data.feb.value
          pl_year.mar.value = pl_year.feb.value + this.edit_data.mar.value
          pl_year.apr.value = pl_year.mar.value + this.edit_data.apr.value
          pl_year.may.value = pl_year.apr.value + this.edit_data.may.value
          pl_year.jun.value = pl_year.may.value + this.edit_data.jun.value
          pl_year.jul.value = pl_year.jun.value + this.edit_data.jul.value
          pl_year.aug.value = pl_year.jul.value + this.edit_data.aug.value
          pl_year.sep.value = pl_year.aug.value + this.edit_data.sep.value

          pl_year.oct = JSON.stringify(pl_year.oct)
          pl_year.nov = JSON.stringify(pl_year.nov)
          pl_year.dec = JSON.stringify(pl_year.dec)
          pl_year.jan = JSON.stringify(pl_year.jan)
          pl_year.feb = JSON.stringify(pl_year.feb)
          pl_year.mar = JSON.stringify(pl_year.mar)
          pl_year.apr = JSON.stringify(pl_year.apr)
          pl_year.may = JSON.stringify(pl_year.may)
          pl_year.jun = JSON.stringify(pl_year.jun)
          pl_year.jul = JSON.stringify(pl_year.jul)
          pl_year.aug = JSON.stringify(pl_year.aug)
          pl_year.sep = JSON.stringify(pl_year.sep)

          if (stash.length > 0) {
            stash = stash[0]
            //กำไร/ขาดทุนสะสม
            let adjust = this.select_data.gf.filter((data: any) => {
              return data.list.match('รายการปรับปรุงมีผลกระทบปี งปม.' + (this.year_select - 1))
            })
            if (adjust.length > 0) {
              adjust = adjust[0]
              stash.oct.value = parseFloat(stash.ori_balance) + this.edit_data.oct.value + parseFloat(adjust.oct.value)
              stash.nov.value = parseFloat(stash.oct.value) + this.edit_data.nov.value + parseFloat(adjust.nov.value)
              stash.dec.value = parseFloat(stash.nov.value) + this.edit_data.dec.value + parseFloat(adjust.dec.value)
              stash.jan.value = parseFloat(stash.dec.value) + this.edit_data.jan.value + parseFloat(adjust.jan.value)
              stash.feb.value = parseFloat(stash.jan.value) + this.edit_data.feb.value + parseFloat(adjust.feb.value)
              stash.mar.value = parseFloat(stash.feb.value) + this.edit_data.mar.value + parseFloat(adjust.mar.value)
              stash.apr.value = parseFloat(stash.mar.value) + this.edit_data.apr.value + parseFloat(adjust.apr.value)
              stash.may.value = parseFloat(stash.apr.value) + this.edit_data.may.value + parseFloat(adjust.may.value)
              stash.jun.value = parseFloat(stash.may.value) + this.edit_data.jun.value + parseFloat(adjust.jun.value)
              stash.jul.value = parseFloat(stash.jun.value) + this.edit_data.jul.value + parseFloat(adjust.jul.value)
              stash.aug.value = parseFloat(stash.jul.value) + this.edit_data.aug.value + parseFloat(adjust.aug.value)
              stash.sep.value = parseFloat(stash.aug.value) + this.edit_data.sep.value + parseFloat(adjust.sep.value)

              stash.oct = JSON.stringify(stash.oct)
              stash.nov = JSON.stringify(stash.nov)
              stash.dec = JSON.stringify(stash.dec)
              stash.jan = JSON.stringify(stash.jan)
              stash.feb = JSON.stringify(stash.feb)
              stash.mar = JSON.stringify(stash.mar)
              stash.apr = JSON.stringify(stash.apr)
              stash.may = JSON.stringify(stash.may)
              stash.jun = JSON.stringify(stash.jun)
              stash.jul = JSON.stringify(stash.jul)
              stash.aug = JSON.stringify(stash.aug)
              stash.sep = JSON.stringify(stash.sep)
            }
          }
        }
      } else if (data.list === "รายการปรับปรุงมีผลกระทบปี งปม." + (this.year_select - 1)) {
        stash = this.select_data.gf.filter((res: any) => {
          return res.list.match("กำไร/ขาดทุนสะสม")
        })
        pl = this.select_data.gf.filter((data: any) => {
          return data.list.match("P/L MONTH")
        })

        if (stash.length > 0) {
          stash = stash[0]
          if (pl?.length > 0) {
            pl = pl[0]
          } else {
            pl = {
              ori_balance: 0,
              oct: {
                value: 0,
                comment: ''
              },
              nov: {
                value: 0,
                comment: ''
              },
              dec: {
                value: 0,
                comment: ''
              },
              jan: {
                value: 0,
                comment: ''
              },
              feb: {
                value: 0,
                comment: ''
              },
              mar: {
                value: 0,
                comment: ''
              },
              apr: {
                value: 0,
                comment: ''
              },
              may: {
                value: 0,
                comment: ''
              },
              jun: {
                value: 0,
                comment: ''
              },
              jul: {
                value: 0,
                comment: ''
              },
              aug: {
                value: 0,
                comment: ''
              },
              sep: {
                value: 0,
                comment: ''
              },
              user_id: 0,
              status: ''
            }
          }
          stash.oct.value = parseFloat(stash.ori_balance) + parseFloat(pl.oct.value) + this.edit_data.oct.value
          stash.nov.value = parseFloat(stash.oct.value) + parseFloat(pl.nov.value) + this.edit_data.nov.value
          stash.dec.value = parseFloat(stash.nov.value) + parseFloat(pl.dec.value) + this.edit_data.dec.value
          stash.jan.value = parseFloat(stash.dec.value) + parseFloat(pl.jan.value) + this.edit_data.jan.value
          stash.feb.value = parseFloat(stash.jan.value) + parseFloat(pl.feb.value) + this.edit_data.feb.value
          stash.mar.value = parseFloat(stash.feb.value) + parseFloat(pl.mar.value) + this.edit_data.mar.value
          stash.apr.value = parseFloat(stash.mar.value) + parseFloat(pl.apr.value) + this.edit_data.apr.value
          stash.may.value = parseFloat(stash.apr.value) + parseFloat(pl.may.value) + this.edit_data.may.value
          stash.jun.value = parseFloat(stash.may.value) + parseFloat(pl.jun.value) + this.edit_data.jun.value
          stash.jul.value = parseFloat(stash.jun.value) + parseFloat(pl.jul.value) + this.edit_data.jul.value
          stash.aug.value = parseFloat(stash.jul.value) + parseFloat(pl.aug.value) + this.edit_data.aug.value
          stash.sep.value = parseFloat(stash.aug.value) + parseFloat(pl.sep.value) + this.edit_data.sep.value

          stash.oct = JSON.stringify(stash.oct)
          stash.nov = JSON.stringify(stash.nov)
          stash.dec = JSON.stringify(stash.dec)
          stash.jan = JSON.stringify(stash.jan)
          stash.feb = JSON.stringify(stash.feb)
          stash.mar = JSON.stringify(stash.mar)
          stash.apr = JSON.stringify(stash.apr)
          stash.may = JSON.stringify(stash.may)
          stash.jun = JSON.stringify(stash.jun)
          stash.jul = JSON.stringify(stash.jul)
          stash.aug = JSON.stringify(stash.aug)
          stash.sep = JSON.stringify(stash.sep)
        }

      }
    } else if (this.edit_data.type == "NBMS") {
      if (data.list === "P/L MONTH") {
        pl_year = this.select_data.nb.filter((res: any) => {
          return res.list.match("P/L ปี งปม." + this.year_select)
        })
        stash = this.select_data.nb.filter((res: any) => {
          return res.list.match("กำไร/ขาดทุนสะสม")
        })
        if (pl_year.length > 0) {
          pl_year = pl_year[0];

          //P/L ปี งปม.
          pl_year.oct.value = this.edit_data.oct.value
          pl_year.nov.value = pl_year.oct.value + this.edit_data.nov.value
          pl_year.dec.value = pl_year.nov.value + this.edit_data.dec.value
          pl_year.jan.value = pl_year.dec.value + this.edit_data.jan.value
          pl_year.feb.value = pl_year.jan.value + this.edit_data.feb.value
          pl_year.mar.value = pl_year.feb.value + this.edit_data.mar.value
          pl_year.apr.value = pl_year.mar.value + this.edit_data.apr.value
          pl_year.may.value = pl_year.apr.value + this.edit_data.may.value
          pl_year.jun.value = pl_year.may.value + this.edit_data.jun.value
          pl_year.jul.value = pl_year.jun.value + this.edit_data.jul.value
          pl_year.aug.value = pl_year.jul.value + this.edit_data.aug.value
          pl_year.sep.value = pl_year.aug.value + this.edit_data.sep.value

          pl_year.oct = JSON.stringify(pl_year.oct)
          pl_year.nov = JSON.stringify(pl_year.nov)
          pl_year.dec = JSON.stringify(pl_year.dec)
          pl_year.jan = JSON.stringify(pl_year.jan)
          pl_year.feb = JSON.stringify(pl_year.feb)
          pl_year.mar = JSON.stringify(pl_year.mar)
          pl_year.apr = JSON.stringify(pl_year.apr)
          pl_year.may = JSON.stringify(pl_year.may)
          pl_year.jun = JSON.stringify(pl_year.jun)
          pl_year.jul = JSON.stringify(pl_year.jul)
          pl_year.aug = JSON.stringify(pl_year.aug)
          pl_year.sep = JSON.stringify(pl_year.sep)

          if (stash.length > 0) {
            stash = stash[0]
            //กำไร/ขาดทุนสะสม
            let adjust = this.select_data.gf.filter((data: any) => {
              return data.list.match('รายการปรับปรุงมีผลกระทบปี งปม.' + (this.year_select - 1))
            })
            if (adjust.length > 0) {
              adjust = adjust[0]
              stash.oct.value = parseFloat(stash.ori_balance) + this.edit_data.oct.value + parseFloat(adjust.oct.value)
              stash.nov.value = parseFloat(stash.oct.value) + this.edit_data.nov.value + parseFloat(adjust.nov.value)
              stash.dec.value = parseFloat(stash.nov.value) + this.edit_data.dec.value + parseFloat(adjust.dec.value)
              stash.jan.value = parseFloat(stash.dec.value) + this.edit_data.jan.value + parseFloat(adjust.jan.value)
              stash.feb.value = parseFloat(stash.jan.value) + this.edit_data.feb.value + parseFloat(adjust.feb.value)
              stash.mar.value = parseFloat(stash.feb.value) + this.edit_data.mar.value + parseFloat(adjust.mar.value)
              stash.apr.value = parseFloat(stash.mar.value) + this.edit_data.apr.value + parseFloat(adjust.apr.value)
              stash.may.value = parseFloat(stash.apr.value) + this.edit_data.may.value + parseFloat(adjust.may.value)
              stash.jun.value = parseFloat(stash.may.value) + this.edit_data.jun.value + parseFloat(adjust.jun.value)
              stash.jul.value = parseFloat(stash.jun.value) + this.edit_data.jul.value + parseFloat(adjust.jul.value)
              stash.aug.value = parseFloat(stash.jul.value) + this.edit_data.aug.value + parseFloat(adjust.aug.value)
              stash.sep.value = parseFloat(stash.aug.value) + this.edit_data.sep.value + parseFloat(adjust.sep.value)

              stash.oct = JSON.stringify(stash.oct)
              stash.nov = JSON.stringify(stash.nov)
              stash.dec = JSON.stringify(stash.dec)
              stash.jan = JSON.stringify(stash.jan)
              stash.feb = JSON.stringify(stash.feb)
              stash.mar = JSON.stringify(stash.mar)
              stash.apr = JSON.stringify(stash.apr)
              stash.may = JSON.stringify(stash.may)
              stash.jun = JSON.stringify(stash.jun)
              stash.jul = JSON.stringify(stash.jul)
              stash.aug = JSON.stringify(stash.aug)
              stash.sep = JSON.stringify(stash.sep)
            }
          }
        }
      } else if (data.list === "รายการปรับปรุงมีผลกระทบปี งปม." + (this.year_select - 1)) {
        stash = this.select_data.nb.filter((res: any) => {
          return res.list.match("กำไร/ขาดทุนสะสม")
        })
        pl = this.select_data.nb.filter((data: any) => {
          return data.list.match("P/L MONTH")
        })

        if (stash.length > 0) {
          stash = stash[0]
          if (pl?.length > 0) {
            pl = pl[0]
          } else {
            pl = {
              ori_balance: 0,
              oct: {
                value: 0,
                comment: ''
              },
              nov: {
                value: 0,
                comment: ''
              },
              dec: {
                value: 0,
                comment: ''
              },
              jan: {
                value: 0,
                comment: ''
              },
              feb: {
                value: 0,
                comment: ''
              },
              mar: {
                value: 0,
                comment: ''
              },
              apr: {
                value: 0,
                comment: ''
              },
              may: {
                value: 0,
                comment: ''
              },
              jun: {
                value: 0,
                comment: ''
              },
              jul: {
                value: 0,
                comment: ''
              },
              aug: {
                value: 0,
                comment: ''
              },
              sep: {
                value: 0,
                comment: ''
              },
              user_id: 0,
              status: ''
            }
          }
          stash.oct.value = parseFloat(stash.ori_balance) + parseFloat(pl.oct.value) + this.edit_data.oct.value
          stash.nov.value = parseFloat(stash.oct.value) + parseFloat(pl.nov.value) + this.edit_data.nov.value
          stash.dec.value = parseFloat(stash.nov.value) + parseFloat(pl.dec.value) + this.edit_data.dec.value
          stash.jan.value = parseFloat(stash.dec.value) + parseFloat(pl.jan.value) + this.edit_data.jan.value
          stash.feb.value = parseFloat(stash.jan.value) + parseFloat(pl.feb.value) + this.edit_data.feb.value
          stash.mar.value = parseFloat(stash.feb.value) + parseFloat(pl.mar.value) + this.edit_data.mar.value
          stash.apr.value = parseFloat(stash.mar.value) + parseFloat(pl.apr.value) + this.edit_data.apr.value
          stash.may.value = parseFloat(stash.apr.value) + parseFloat(pl.may.value) + this.edit_data.may.value
          stash.jun.value = parseFloat(stash.may.value) + parseFloat(pl.jun.value) + this.edit_data.jun.value
          stash.jul.value = parseFloat(stash.jun.value) + parseFloat(pl.jul.value) + this.edit_data.jul.value
          stash.aug.value = parseFloat(stash.jul.value) + parseFloat(pl.aug.value) + this.edit_data.aug.value
          stash.sep.value = parseFloat(stash.aug.value) + parseFloat(pl.sep.value) + this.edit_data.sep.value

          stash.oct = JSON.stringify(stash.oct)
          stash.nov = JSON.stringify(stash.nov)
          stash.dec = JSON.stringify(stash.dec)
          stash.jan = JSON.stringify(stash.jan)
          stash.feb = JSON.stringify(stash.feb)
          stash.mar = JSON.stringify(stash.mar)
          stash.apr = JSON.stringify(stash.apr)
          stash.may = JSON.stringify(stash.may)
          stash.jun = JSON.stringify(stash.jun)
          stash.jul = JSON.stringify(stash.jul)
          stash.aug = JSON.stringify(stash.aug)
          stash.sep = JSON.stringify(stash.sep)
        }

      }
    }
    let update_data = {
      fiscal_year: this.edit_data.fiscal_year,
      type: this.edit_data.type,
      code: this.edit_data.code,
      list: this.edit_data.list,
      ori_balance: this.edit_data.ori_balance,
      oct: JSON.stringify(this.edit_data.oct),
      nov: JSON.stringify(this.edit_data.nov),
      dec: JSON.stringify(this.edit_data.dec),
      jan: JSON.stringify(this.edit_data.jan),
      feb: JSON.stringify(this.edit_data.feb),
      mar: JSON.stringify(this.edit_data.mar),
      apr: JSON.stringify(this.edit_data.apr),
      may: JSON.stringify(this.edit_data.may),
      jun: JSON.stringify(this.edit_data.jun),
      jul: JSON.stringify(this.edit_data.jul),
      aug: JSON.stringify(this.edit_data.aug),
      sep: JSON.stringify(this.edit_data.sep),
      adjust: this.edit_data.adjust,
      user_id: parseInt(this.admin_data.id),
      status: this.edit_data.status
    }
    Swal.fire({
      title: 'ยืนยันการแก้ไขรายการ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true
    }).then((res: any) => {
      if (res.isConfirmed == true) {
        this.services.update('m_trialbalance', parseInt(data.id), update_data).then((res: any) => {
          if (pl_year?.length != 0) {
            this.services.update('m_trialbalance', parseInt(pl_year?.id), pl_year!)
          }
          if (stash?.length != 0) {
            this.services.update('m_trialbalance', parseInt(stash?.id), stash!)
          }
          this.getDataAlll();
          Swal.fire({
            title: 'แก้ไขรายการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
          this.onClickClose();
        })
      }
    })

  }
  async onClickClose() {
    this.enableEdit = false
    this.enableEditIndex = null
    this.edit_data = {
      fiscal_year: 0,
      type: '',
      code: '',
      list: '',
      ori_balance: 0,
      oct: {
        value: 0,
        comment: ''
      },
      nov: {
        value: 0,
        comment: ''
      },
      dec: {
        value: 0,
        comment: ''
      },
      jan: {
        value: 0,
        comment: ''
      },
      feb: {
        value: 0,
        comment: ''
      },
      mar: {
        value: 0,
        comment: ''
      },
      apr: {
        value: 0,
        comment: ''
      },
      may: {
        value: 0,
        comment: ''
      },
      jun: {
        value: 0,
        comment: ''
      },
      jul: {
        value: 0,
        comment: ''
      },
      aug: {
        value: 0,
        comment: ''
      },
      sep: {
        value: 0,
        comment: ''
      },
      adjust: '',
      user_id: 0,
      status: ''
    }
  }
  onClickTap() {
    this.enableEdit = false
    this.enableEditIndex = null
    this.enableAdd = false
    this.edit_data = {
      fiscal_year: 0,
      type: '',
      code: '',
      list: '',
      ori_balance: 0,
      oct: {
        value: 0,
        comment: ''
      },
      nov: {
        value: 0,
        comment: ''
      },
      dec: {
        value: 0,
        comment: ''
      },
      jan: {
        value: 0,
        comment: ''
      },
      feb: {
        value: 0,
        comment: ''
      },
      mar: {
        value: 0,
        comment: ''
      },
      apr: {
        value: 0,
        comment: ''
      },
      may: {
        value: 0,
        comment: ''
      },
      jun: {
        value: 0,
        comment: ''
      },
      jul: {
        value: 0,
        comment: ''
      },
      aug: {
        value: 0,
        comment: ''
      },
      sep: {
        value: 0,
        comment: ''
      },
      adjust: '',
      user_id: 0,
      status: ''
    }
  }

  createSumCol() {
    this.sumCol = {
      code: '',
      list: '',
      ori_balance: 0,
      oct: {
        value: 0,
        comment: ''
      },
      nov: {
        value: 0,
        comment: ''
      },
      dec: {
        value: 0,
        comment: ''
      },
      jan: {
        value: 0,
        comment: ''
      },
      feb: {
        value: 0,
        comment: ''
      },
      mar: {
        value: 0,
        comment: ''
      },
      apr: {
        value: 0,
        comment: ''
      },
      may: {
        value: 0,
        comment: ''
      },
      jun: {
        value: 0,
        comment: ''
      },
      jul: {
        value: 0,
        comment: ''
      },
      aug: {
        value: 0,
        comment: ''
      },
      sep: {
        value: 0,
        comment: ''
      },
      sumRow: 0
    }
  }
  sumColumn(data: any) {
    this.sumCol.ori_balance += parseFloat(data.ori_balance)
    this.sumCol.oct.value += parseFloat(data.oct.value)
    this.sumCol.nov.value += parseFloat(data.nov.value)
    this.sumCol.dec.value += parseFloat(data.dec.value)
    this.sumCol.jan.value += parseFloat(data.jan.value)
    this.sumCol.feb.value += parseFloat(data.feb.value)
    this.sumCol.mar.value += parseFloat(data.mar.value)
    this.sumCol.apr.value += parseFloat(data.apr.value)
    this.sumCol.may.value += parseFloat(data.may.value)
    this.sumCol.jun.value += parseFloat(data.jun.value)
    this.sumCol.jul.value += parseFloat(data.jul.value)
    this.sumCol.aug.value += parseFloat(data.aug.value)
    this.sumCol.sep.value += parseFloat(data.sep.value)
    this.sumCol.sumRow += parseFloat(data.sumRow)
  }
  sumDiff(data: any) {
    this.diff.ori_balance += parseFloat(data.ori_balance)
    this.diff.oct.value += parseFloat(data.oct.value)
    this.diff.nov.value += parseFloat(data.nov.value)
    this.diff.dec.value += parseFloat(data.dec.value)
    this.diff.jan.value += parseFloat(data.jan.value)
    this.diff.feb.value += parseFloat(data.feb.value)
    this.diff.mar.value += parseFloat(data.mar.value)
    this.diff.apr.value += parseFloat(data.apr.value)
    this.diff.may.value += parseFloat(data.may.value)
    this.diff.jun.value += parseFloat(data.jun.value)
    this.diff.jul.value += parseFloat(data.jul.value)
    this.diff.aug.value += parseFloat(data.aug.value)
    this.diff.sep.value += parseFloat(data.sep.value)
    this.diff.sumRow += parseFloat(data.sumRow)
  }
  sumDiffGN(gf: any, nb: any) {
    if (gf && nb) {
      this.diff_gn.ori_balance = parseFloat(gf.ori_balance) - parseFloat(nb.ori_balance)
      this.diff_gn.oct.value = parseFloat(gf.oct.value) - parseFloat(nb.oct.value)
      this.diff_gn.nov.value = parseFloat(gf.nov.value) - parseFloat(nb.nov.value)
      this.diff_gn.dec.value = parseFloat(gf.dec.value) - parseFloat(nb.dec.value)
      this.diff_gn.jan.value = parseFloat(gf.jan.value) - parseFloat(nb.jan.value)
      this.diff_gn.feb.value = parseFloat(gf.feb.value) - parseFloat(nb.feb.value)
      this.diff_gn.mar.value = parseFloat(gf.mar.value) - parseFloat(nb.mar.value)
      this.diff_gn.apr.value = parseFloat(gf.apr.value) - parseFloat(nb.apr.value)
      this.diff_gn.may.value = parseFloat(gf.may.value) - parseFloat(nb.may.value)
      this.diff_gn.jun.value = parseFloat(gf.jun.value) - parseFloat(nb.jun.value)
      this.diff_gn.jul.value = parseFloat(gf.jul.value) - parseFloat(nb.jul.value)
      this.diff_gn.aug.value = parseFloat(gf.aug.value) - parseFloat(nb.aug.value)
      this.diff_gn.sep.value = parseFloat(gf.sep.value) - parseFloat(nb.sep.value)
      this.diff_gn.sumRow = parseFloat(gf.sumRow) - parseFloat(nb.sumRow)
    }
  }

  //select input list gf/nb
  onSelectList(type: any) {
    let pl: any
    if (type == 'gf') {
      pl = this.select_data.gf.filter((data: any) => {
        return data.list.match('P/L MONTH')
      })
    } else {
      pl = this.select_data.nb.filter((data: any) => {
        return data.list.match('P/L MONTH')
      })
    }
    pl = pl[0]

    if (this.edit_data.list == 'P/L ปี งปม.' + this.year_select) {
      this.edit_data.oct.value = pl.oct.value
      this.edit_data.nov.value = this.edit_data.oct.value + pl.nov.value
      this.edit_data.dec.value = this.edit_data.nov.value + pl.dec.value
      this.edit_data.jan.value = this.edit_data.dec.value + pl.jan.value
      this.edit_data.feb.value = this.edit_data.jan.value + pl.feb.value
      this.edit_data.mar.value = this.edit_data.feb.value + pl.mar.value
      this.edit_data.apr.value = this.edit_data.mar.value + pl.apr.value
      this.edit_data.may.value = this.edit_data.apr.value + pl.may.value
      this.edit_data.jun.value = this.edit_data.may.value + pl.jun.value
      this.edit_data.jul.value = this.edit_data.jun.value + pl.jul.value
      this.edit_data.aug.value = this.edit_data.jul.value + pl.aug.value
      this.edit_data.sep.value = this.edit_data.aug.value + pl.sep.value
    }
  }
  //input ori_balance gf/nb
  onInput(type: any) {
    let pl: any
    let adjust: any
    if (type == 'gf') {
      pl = this.select_data.gf.filter((data: any) => {
        return data.list.match('P/L MONTH')
      })
      adjust = this.select_data.gf.filter((data: any) => {
        return data.list.match('รายการปรับปรุงมีผลกระทบปี งปม.' + (this.year_select - 1))
      })
    } else {
      pl = this.select_data.nb.filter((data: any) => {
        return data.list.match('P/L MONTH')
      })
      adjust = this.select_data.nb.filter((data: any) => {
        return data.list.match('รายการปรับปรุงมีผลกระทบปี งปม.' + (this.year_select - 1))
      })
    }
    pl = pl[0]
    adjust = adjust[0]

    if (this.edit_data.list == 'กำไร/ขาดทุนสะสม') {
      this.edit_data.oct.value = this.edit_data.ori_balance + pl.oct.value + adjust.oct.value
      this.edit_data.nov.value = this.edit_data.oct.value + pl.nov.value + adjust.nov.value
      this.edit_data.dec.value = this.edit_data.nov.value + pl.dec.value + adjust.dec.value
      this.edit_data.jan.value = this.edit_data.dec.value + pl.jan.value + adjust.jan.value
      this.edit_data.feb.value = this.edit_data.jan.value + pl.feb.value + adjust.feb.value
      this.edit_data.mar.value = this.edit_data.feb.value + pl.mar.value + adjust.mar.value
      this.edit_data.apr.value = this.edit_data.mar.value + pl.apr.value + adjust.apr.value
      this.edit_data.may.value = this.edit_data.apr.value + pl.may.value + adjust.may.value
      this.edit_data.jun.value = this.edit_data.may.value + pl.jun.value + adjust.jun.value
      this.edit_data.jul.value = this.edit_data.jun.value + pl.jul.value + adjust.jul.value
      this.edit_data.aug.value = this.edit_data.jul.value + pl.aug.value + adjust.aug.value
      this.edit_data.sep.value = this.edit_data.aug.value + pl.sep.value + adjust.sep.value
    }
  }

  //func Round decimal
  fixDecimal(x: any) {
    if (x == 0 || x == null) {
      return 0
    } else {
      return Math.round(x * 100) / 100;
    }
  }
  fixNumber(data: any) {
    data.ori_balanceview = this.fixNull(parseFloat(data.ori_balance))
    data.oct.view = this.fixNull(data.oct.value)
    data.nov.view = this.fixNull(data.nov.value)
    data.dec.view = this.fixNull(data.dec.value)
    data.jan.view = this.fixNull(data.jan.value)
    data.feb.view = this.fixNull(data.feb.value)
    data.mar.view = this.fixNull(data.mar.value)
    data.apr.view = this.fixNull(data.apr.value)
    data.may.view = this.fixNull(data.may.value)
    data.jun.view = this.fixNull(data.jun.value)
    data.jul.view = this.fixNull(data.jul.value)
    data.aug.view = this.fixNull(data.aug.value)
    data.sep.view = this.fixNull(data.sep.value)
    data.sumRowview = this.fixNull(data.sumRow)
    return data
  }
  fixData(data: any) {
    data.ori_balance = this.fixZero(data.ori_balance)
    data.oct.value = this.fixZero(data.oct.value)
    data.nov.value = this.fixZero(data.nov.value)
    data.dec.value = this.fixZero(data.dec.value)
    data.jan.value = this.fixZero(data.jan.value)
    data.feb.value = this.fixZero(data.feb.value)
    data.mar.value = this.fixZero(data.mar.value)
    data.apr.value = this.fixZero(data.apr.value)
    data.may.value = this.fixZero(data.may.value)
    data.jun.value = this.fixZero(data.jun.value)
    data.jul.value = this.fixZero(data.jul.value)
    data.aug.value = this.fixZero(data.aug.value)
    data.sep.value = this.fixZero(data.sep.value)
    return data
  }
  fixZero(x: any) {
    if (x == null) {
      return 0;
    }
    else {
      return parseFloat(x);
    }
  }
  fixNull(x: any) {
    if (x == 0) {
      return null;
    }
    else {
      return parseFloat(x);
    }
  }

  maximizeorMinimize(table_name: any, btn_name: any) {
    var table = document.getElementById(table_name);
    var btn = document.getElementById(btn_name);
    if (!this.maximized) {
      table!.style.position = 'fixed';
      table!.style.zIndex = '99';
      table!.style.background = 'white';
      table!.style.width = "100vw";
      table!.style.height = "85vh";
      table!.style.top = "12%";
      table!.style.left = "0";
      btn!.setAttribute('src', "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEX///8AAADo6OgwMDB0dHTCwsI3NzdwcHAgICDU1NRhYWGWlpZLS0va2tqSkpLHx8e5ublZWVknJyfe3t5BQUGjo6NmZmYXFxf19fVTU1NcXFympqavr68YGBgODg62trZ7e3vm1eqLAAACtUlEQVR4nO3d7VLiQBBGYT5CICQIsqIssuj9X+UWtaXlTK2ka7rdd9Y6zwUMc0xiBn/YkwkAAAAAAAAAAMB/aNs3QzvXaoem335N3mI9rcd6Ed53uKijMpdDaF+3Ugf9xX4TF3injvlEHxVY0wOYeowJfFB33DBEBNZ7Ba8CrmKtz+Ab97PYqQtGeX+j7tUBo1pf4LN6/wZnV6F69xYrT+CLevcmnjPqkC922nUzrW53n29qXR54zJba/3D8tOJs8lNy+VKLdKHVMW6XLsfsi05XvFL2tq/jCl5lb+nyt356YHPc7uF+Jjt7LV6nTdbZhe3P75zsrPz8Pa/0Js1v0/JjTVo4C9yh1yzZ2bx4HQp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCK3tht4h367+S/vvC5TTesqrC5gsKGwoppJBCCimkkEIKgwu//7n0sGyiLW8NVuP7oRWFOhRaUahDoRWFOhRaUahDoRWFOhRaUahDoRWFOlGF6YRH73joSJtkZ+XzD9O58S+BO/RKBxU/FK+T/p33FLhDr3Qm8K2/Hd/WJ+tUNKYzvUkds2S36UL1zAN+Sje2LV8qXegbznTOxu5OK53Lfe8o3OWLVckzW31yGV9f7pcnMJudXKezq3CyV+9/VPmR7Y9u/CPE3IfJu/HPkCp/279bj3+K0KM/MD9/16V8bnyi3qsYcgWvan0WA57BN11+EqzBPvYr+UHdk3t6Du272p3UUR+sXWfRz237ZmjnWu3Q9I7vgwAAAAAAAAAAADq/AeDROLr9IlTcAAAAAElFTkSuQmCC");
      btn!.style.width = "30px";
      btn!.style.height = "30px";
      btn!.style.marginRight = "15px";
      btn!.title = "Minimize";
      this.maximized = true;
    } else {
      table!.style.position = 'relative';
      table!.style.zIndex = '5';
      table!.style.width = "100%";
      table!.style.height = "100vh";
      table!.style.top = "0%";
      table!.style.borderRadius = "15px";
      btn!.title = "Maximize";
      btn!.style.width = "15px";
      btn!.style.height = "15px";
      btn!.style.marginRight = "5px";
      btn!.style.marginTop = "5px";
      btn!.setAttribute('src', "https://cdn2.iconfinder.com/data/icons/mixed-vol-7/74/Untitled-1-11-08-07-17-512.png");
      this.maximized = false;
    }
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    // document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }
}
